import React, { Component } from 'react';
import { Formik } from 'formik';
import xhr from 'xhr';
import qs from 'qs';
import styles from './ContactForm.module.scss';

const FORM_NAME = 'contact-form';
const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export default class ContactForm extends Component {
  validate(values) {
    const errors = {};

    if (!values.name) {
      errors.name = 'Required';
    }

    if (!values.email) {
      errors.email = 'Required';
    } else if (!EMAIL_REGEX.test(values.email)) {
      errors.email = 'Must be a valid e-mail address';
    }

    if (!values.phone) {
      errors.phone = 'Required';
    }

    if (!values.message || values.message.length < 5) {
      errors.message = 'Required';
    }

    if (!window.grecaptcha || !window.grecaptcha.getResponse()) {
      errors.recaptcha = 'Required';
    }

    return errors;
  }

  submit = (values, { resetForm, setSubmitting, setErrors, setStatus }) => {
    setStatus();

    xhr({
      method: 'post',
      url: '/contact-form',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: qs.stringify({
        'form-name': FORM_NAME,
        'g-recaptcha-response': window.grecaptcha && window.grecaptcha.getResponse(),
        ...values,
      }),
    }, (err) => {
      if (err) {
        setErrors({ submit: err.message });
        setSubmitting(false);
      } else {
        resetForm();
        setStatus('submitted');
      }

      window.grecaptcha && window.grecaptcha.reset();
    });
  };

  renderForm = ({ values, touched, errors, handleChange, handleBlur, handleSubmit, isSubmitting, status }) => {
    return (
      <form
        className={styles.form}
        onSubmit={handleSubmit}
        action={FORM_NAME}
        name={FORM_NAME}
        data-netlify="true"
        data-netlify-honeypot="honeypot"
        data-netlify-recaptcha
      >
        <div className={styles.group}>
          <label className={styles.label} htmlFor="contactName">Full Name</label>
          <input
            className={styles.control}
            type="text"
            id="contactName"
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {!!(touched.name && errors.name) && (
            <div className={styles.error}>{errors.name}</div>
          )}
        </div>
        <div className={styles.double}>
          <div className={styles.group}>
            <label className={styles.label} htmlFor="contactEmail">E-mail</label>
            <input
              className={styles.control}
              type="email"
              id="contactEmail"
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {!!(touched.email && errors.email) && (
              <div className={styles.error}>{errors.email}</div>
            )}
          </div>
          <div className={styles.group}>
            <label className={styles.label} htmlFor="contactPhone">Phone No.</label>
            <input
              className={styles.control}
              type="tel"
              id="contactPhone"
              name="phone"
              value={values.phone}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {!!(touched.phone && errors.phone) && (
              <div className={styles.error}>{errors.phone}</div>
            )}
          </div>
        </div>
        <div className={styles.group}>
          <label className={styles.label} htmlFor="contactMessage">Message</label>
          <textarea
            className={styles.control}
            id="contactMessage"
            name="message"
            rows="7"
            value={values.message}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {!!(touched.message && errors.message) && (
            <div className={styles.error}>{errors.message}</div>
          )}
        </div>
        <div className={styles.group}>
          <div className="g-recaptcha" data-sitekey="6Lc97UYUAAAAAFsBPlNGmjbQ03jKMIuNxl7e0Zdr" />
          {errors.recaptcha && (
            <div className={styles.error}>{errors.recaptcha}</div>
          )}
        </div>
        <div className={styles.honeypot}>
          <input type="text" name="honeypot" />
        </div>
        <button className={styles.button} type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Sending…' : 'Send'}
        </button>
        {(status === 'submitted') && (
          <div className={styles.success}>
            Thank you for reaching out, we’ll get back to you ASAP!
          </div>
        )}
        {!!errors.submit && (
          <div className={styles.error}>
            An error occurred while submitting the form. Please try again later
          </div>
        )}
      </form>
    );
  };

  render() {
    return (
      <Formik
        ref={instance => (this.instance = instance)}
        initialValues={{
          name: '',
          email: '',
          phone: '',
          message: '',
        }}
        validate={this.validate}
        onSubmit={this.submit}
        render={this.renderForm}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactForm.js